/** 진행단계 chevron — 단계 인덱스별 톤 (SIMMS 브랜드 계열) */
const STEPPER_TONES = [
    {bg: "#dfa018", soft: "#fff8e8", text: "#8a5c00", shadow: "rgba(223, 160, 24, 0.38)"},
    {bg: "#e67a38", soft: "#fff1e8", text: "#9a4518", shadow: "rgba(230, 122, 56, 0.38)"},
    {bg: "#3b9ae8", soft: "#e9f4fd", text: "#1a5f9e", shadow: "rgba(59, 154, 232, 0.38)"},
    {bg: "#2da89a", soft: "#e7f7f5", text: "#1a6b62", shadow: "rgba(45, 168, 154, 0.38)"},
    {bg: "#7b6fd6", soft: "#f0edfc", text: "#4a3f9e", shadow: "rgba(123, 111, 214, 0.38)"},
    {bg: "#3da85c", soft: "#ebf7ef", text: "#2a6e3d", shadow: "rgba(61, 168, 92, 0.38)"},
    {bg: "#2d5a8e", soft: "#e8eef6", text: "#1c3f66", shadow: "rgba(45, 90, 142, 0.38)"},
];

export function getStepTone(stepIndex) {
    return STEPPER_TONES[stepIndex % STEPPER_TONES.length];
}

export function getStepToneStyle(stepIndex) {
    const tone = getStepTone(stepIndex);
    return {
        "--step-tone": tone.bg,
        "--step-tone-soft": tone.soft,
        "--step-tone-text": tone.text,
        "--step-tone-shadow": tone.shadow,
    };
}
